<template>
  <div id="geolocation-instructions">
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="modalInstructActivateGeolocation"
      modal-class="modern-geolocation-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-map-marker-alt mr-2"></i>
          Ativar Geolocalização
        </div>
      </template>

      <div class="modal-content-modern">
        <!-- Alert Section -->
        <div class="alert-section">
          <div class="alert-card error-alert">
            <div class="alert-icon">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="alert-content">
              <h4 class="alert-title">Permissão Necessária</h4>
              <p class="alert-message">
                Habilite que o navegador tenha acesso à sua localização atual!
              </p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-icon">
              <i class="fas fa-info-circle"></i>
            </div>
            <p class="info-text">
              Você precisa autorizar o acesso à localização para salvar esse
              tipo de informação.
            </p>
          </div>
        </div>

        <!-- Platform Selection -->
        <div class="platform-section">
          <h3 class="section-title">
            <i class="fas fa-cogs mr-2"></i>
            Selecione sua plataforma
          </h3>

          <div class="platform-tabs">
            <button
              :class="['platform-tab', { active: selected === 'chrome' }]"
              @click="selected = 'chrome'"
              type="button"
            >
              <i class="fab fa-chrome mr-2"></i>
              Chrome Desktop
            </button>
            <button
              :class="['platform-tab', { active: selected === 'app' }]"
              @click="selected = 'app'"
              type="button"
            >
              <i class="fas fa-mobile-alt mr-2"></i>
              App Mobile
            </button>
          </div>
        </div>

        <!-- Instructions Content -->
        <div class="instructions-section">
          <div v-if="selected === 'chrome'" class="instruction-content">
            <div class="instruction-header">
              <div class="instruction-icon chrome-icon">
                <i class="fab fa-chrome"></i>
              </div>
              <div class="instruction-title">
                <h4>Chrome Desktop</h4>
                <p>Como ativar no navegador Chrome</p>
              </div>
            </div>

            <div class="instruction-steps">
              <div class="step-item">
                <div class="step-number">1</div>
                <div class="step-content">
                  <p class="step-text">
                    Clique no ícone ao lado do endereço do site, no canto
                    superior esquerdo
                  </p>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-content">
                  <p class="step-text">
                    Permita o acesso à localização quando solicitado
                  </p>
                </div>
              </div>
            </div>

            <div class="image-container">
              <img
                :src="activeGeolocation"
                alt="Como ativar a localização no Chrome"
                class="instruction-image chrome-image"
              />
            </div>
          </div>

          <div v-if="selected === 'app'" class="instruction-content">
            <div class="instruction-header">
              <div class="instruction-icon app-icon">
                <i class="fas fa-mobile-alt"></i>
              </div>
              <div class="instruction-title">
                <h4>App Mobile</h4>
                <p>Como ativar no aplicativo móvel</p>
              </div>
            </div>

            <div class="instruction-steps">
              <div class="step-item">
                <div class="step-number">1</div>
                <div class="step-content">
                  <p class="step-text">
                    Clique no ícone do Maps no canto superior direito da tela
                  </p>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-content">
                  <p class="step-text">
                    Permita o acesso à localização quando solicitado
                  </p>
                </div>
              </div>
            </div>

            <div class="image-container">
              <img
                :src="appActiveGeolocation"
                alt="Como ativar a localização no App"
                class="instruction-image app-image"
              />
            </div>
          </div>
        </div>

        <!-- Final Instructions -->
        <div class="final-instructions">
          <div class="refresh-card">
            <div class="refresh-icon">
              <i class="fas fa-sync-alt"></i>
            </div>
            <div class="refresh-content">
              <h4 class="refresh-title">Próximo Passo</h4>
              <p class="refresh-text">
                Após conceder a permissão,
                <strong>atualize a página</strong> para aplicar a alteração.
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import activeGeolocation from "@/assets/activeGeolocation.png";
import appActiveGeolocation from "@/assets/appActiveGeolocation.png";

export default {
  name: "InstructActivateGeolocation",
  data() {
    return {
      activeGeolocation,
      appActiveGeolocation,
      selected: "chrome",
    };
  },
  mounted() {
    this.$bvModal.show("modalInstructActivateGeolocation");
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}

.modal-content-modern {
  padding: 8px 0;
}

/* Alert Section */
.alert-section {
  margin-bottom: 32px;
}

.alert-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 16px;
  border: 1px solid;
  transition: all 0.3s ease;
}

.error-alert {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fca5a5;
}

.alert-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  flex-shrink: 0;
}

.alert-content {
  flex: 1;
}

.alert-title {
  font-size: 16px;
  font-weight: 600;
  color: #991b1b;
  margin: 0 0 8px 0;
}

.alert-message {
  font-size: 14px;
  color: #7f1d1d;
  margin: 0;
  line-height: 1.5;
}

.info-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-radius: 8px;
  border: 1px solid #93c5fd;
}

.info-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: white;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  flex-shrink: 0;
}

.info-text {
  font-size: 13px;
  color: #1e40af;
  margin: 0;
  line-height: 1.4;
}

/* Platform Section */
.platform-section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
}

.platform-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.platform-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  border: 2px solid #e5e7eb;
  background: white;
  color: #374151;
  font-weight: 600;
  font-size: 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.platform-tab:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.platform-tab.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-color: #0f65b0;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.platform-tab.active:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4);
}

/* Instructions Section */
.instructions-section {
  margin-bottom: 32px;
}

.instruction-content {
  background: #f8fafc;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e5e7eb;
}

.instruction-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.instruction-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
}

.chrome-icon {
  background: linear-gradient(135deg, #4285f4 0%, #1a73e8 100%);
}

.app-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.instruction-title h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
}

.instruction-title p {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

/* Steps */
.instruction-steps {
  margin-bottom: 24px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.step-item:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
  padding-top: 4px;
}

.step-text {
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.5;
}

/* Images */
.image-container {
  text-align: center;
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.instruction-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.instruction-image:hover {
  transform: scale(1.02);
}

.chrome-image {
  max-width: 320px;
}

.app-image {
  max-width: 280px;
}

/* Final Instructions */
.final-instructions {
  margin-top: 8px;
}

.refresh-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 12px;
  border: 1px solid #86efac;
}

.refresh-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
  animation: pulse 2s infinite;
}

.refresh-content {
  flex: 1;
}

.refresh-title {
  font-size: 16px;
  font-weight: 600;
  color: #166534;
  margin: 0 0 8px 0;
}

.refresh-text {
  font-size: 14px;
  color: #15803d;
  margin: 0;
  line-height: 1.5;
}

.refresh-text strong {
  font-weight: 600;
}

/* Animations */
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content-modern {
    padding: 0;
  }

  .platform-tabs {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .platform-tab {
    padding: 14px 16px;
    font-size: 13px;
  }

  .instruction-content {
    padding: 20px;
  }

  .instruction-header {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .step-item {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .step-number {
    align-self: center;
  }

  .alert-card,
  .refresh-card {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .alert-icon,
  .info-icon,
  .refresh-icon {
    align-self: center;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 16px;
    flex-direction: column;
    gap: 4px;
    text-align: center;
  }

  .instruction-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }

  .instruction-title h4 {
    font-size: 15px;
  }

  .step-text {
    font-size: 13px;
  }

  .image-container {
    padding: 16px;
  }

  .chrome-image,
  .app-image {
    max-width: 100%;
  }
}

/* Override Bootstrap Modal */
:deep(.modern-geolocation-modal .modal-header) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
}

:deep(.modern-geolocation-modal .modal-body) {
  padding: 24px;
}

:deep(.modern-geolocation-modal .modal-dialog) {
  max-width: 700px;
}
</style>